function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  margin-bottom: 0.33rem;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  & > span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  & > ", " {\n    margin-left: auto;\n    display: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0 1rem 0 0.75rem;\n  margin: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 1.5;\n  word-break: break-word;\n  margin-left: 0.8rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding: 1.25rem 1.4rem 0.625rem 1.4rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex: 0 0 50%;\n  overflow: hidden;\n  opacity: ", ";\n\n  &:first-child {\n    margin-left: 1px;\n    border-right: 1px solid ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 22.3125rem;\n  min-height: 10.625rem;\n  font-family: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../theme";
import { AppIconStyle } from "../../appIcon/AppIcon.styles";
export var UserDropdownBodyWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.typography.secondaryFont;
});
export var DropdownBodySection = styled.div(_templateObject2(), function (props) {
  return props.isActive ? '1' : '0.4';
}, function (props) {
  return props.theme.variables.colors.platinum;
});
export var DropdownSectionHeader = styled.div(_templateObject3());
export var DropdownSectionName = styled.span(_templateObject4(), function (props) {
  return props.theme.variables.fonts.weight.bold;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
});
export var ProfilesList = styled.ul(_templateObject5());
export var ProfileRow = styled.li(_templateObject6(), function (props) {
  return props.theme.variables.fonts.weight.regular;
}, function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, AppIconStyle, function (props) {
  return props.isActive ? 'block' : 'none';
});